type CallbackMap = { [key: string]: (result: { op: string }) => void };
const callbacks: CallbackMap = {};

window['OnDialogClose'] = (result: { op: string }) => {
	if (callbacks[result.op]) {
		callbacks[result.op](result);
	}
};

class DialogCloseListener {
	public static subscribe(op: string, callback: (result: { op: string }) => void) {
		callbacks[op] = result => {
			delete callbacks[op];
			callback?.call(this, result);
		};
	}
}

export default DialogCloseListener;
